<template>
    <div id="DPEBBMain" > 
       <span class="Maintitle"> 
          <i class="fas fa-file-prescription"></i>
           <strong> MSSCS Main Application</strong> 
           <span class="float-right"><strong>User ID: {{UserName}}</strong></span>
      </span> 
       <Card>
      <CardBody>
        <p>Any personal health information accessed through the Medical Supplies and Services Claims System (MSSCS) is the property of the Government of Saskatchewan. Access to the contents of this site except by agencies <b>AUTHORIZED BY SASKATCHEWAN HEALTH IN WRITING</b> or their authorized employees is strictly prohibited. All transactions are monitored, logged and reviewed. 
        </p>
        <TileNote>
          <strong>Please Note:</strong> Legal action will be taken against any person accessing information without prior approval from Saskatchewan Health AND THOSE WHO UTILIZE THE INFORMATION FOR UNAUTHORIZED OR UNLAWFUL PURPOSES. 
        </TileNote> 
      </CardBody>
    </Card> 
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
import axios from 'axios' 
 import LayoutDefault from '../../Common/Default/DefaultLayout.vue';
 import Card from "../../Common/Card.vue";
import CardBody from "../../Common/CardBody.vue";
import TileNote from "../../Common/TileNote.vue";
export default  {
  data: function () {
    return {
          //menuitems:""
           AppServiceID :6,
        }
    },
    components: { 
              Card,
            CardBody,
            TileNote            
        },
    methods: {
          Go(){
            this.$router.push('/DPEBB/MainHome')
        }
    },
     computed:{
           UserName(){
            return !this.$store.getters.GetCurrentUser ? false : this.$store.getters.GetCurrentUser;
        },
         IsAuth () {  
             //alert(this.$store.getters.IsAuth)
             return this.$store.getters.IsAuth;
          },
    },
    created: function() {
         
        this.$emit('update:layout', LayoutDefault);
        //this.menuitems = this.$store.getters.GetMainMenu;     
    },
      beforeCreate: function() { 
        //alert('At Dental ')
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDefaultServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDefaultServiceID);
            //this.$store.dispatch('SetBuildMenu');
    },

}
</script>